import './consoleErrorOverride';

// import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client';
import React from 'react';
import { Provider } from 'react-redux';
import './init';
import './Services/Logger';
import buildInfo from '@Utils/buildInfo';
import store from '@Store';
import initToastMessages from '@Containers/ToastMessages';
import initDialogs from '@Containers/Dialogs';
import initAxiosGlobal from '@Services/RequestFactory/AxiosGlobal';
import { init as initGlobalTooltips } from '@Components/Tooltip/GlobalTooltips';
import './Hooks/LibraryInitialization/VendorCss';
import './CustomPolyfill';
import './styles/global.scss';
// eslint-disable-next-line
import SchemasService from '@Services/SchemasService';
import UserActivityWatcher from '@Components/UserActivityWatcher';
import NavigationHistory from '@Services/NavigationHistory';
import AppRoutes from './AppRoutes/AppRoutes';
import '@Containers/GlobalSpinner';

async function initializeApp() {
  buildInfo();
  if (window.isNotFoundPage) {
    const schema = await SchemasService.defaultSchema.getAsync();

    if (schema.use) {
      schema.use();
    }

    SchemasService.hidePagePending();

    return;
  }
  initToastMessages();
  initDialogs();
  initGlobalTooltips();
  initAxiosGlobal();
  NavigationHistory.init();

  createRoot(document.getElementById('root')).render(
    <Provider store={store}>
      <AppRoutes />
      <UserActivityWatcher />
    </Provider>
  );
}

if (!window.isTest) {
  initializeApp();
}
